import { render, staticRenderFns } from "./modalAddSponsoredPlayer.vue?vue&type=template&id=dfb2c69a&"
import script from "./modalAddSponsoredPlayer.vue?vue&type=script&lang=js&"
export * from "./modalAddSponsoredPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports